import {
  CurrencyValue,
  LineChart,
  formatCurrency,
  formatNumber
} from '@blockanalitica/ui';
import type { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { ReactNode, useCallback } from 'react';
import { useChartPeriod } from '@/hooks';

export default function HistoricGraphs({
  data,
  type,
  timeFilter,
  chartDaysAgo
}: {
  data: {
    results: SimpleChartData[];
    debt_symbol: string;
    debt_address: string;
  };
  type: string;
  timeFilter: ReactNode;
  chartDaysAgo: string | number;
}) {
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();
  const valueFormatter = useCallback(
    (value: number) => {
      if (type === 'debt') {
        return (
          <CurrencyValue
            value={value}
            options={{
              currency: {
                name: data.debt_symbol,
                address: data.debt_address
              },
              iconSize: '3'
            }}
          />
        );
      } else {
        return (
          <CurrencyValue
            value={value}
            variant="dynamic"
            options={{
              currency: 'USD'
            }}
          />
        );
      }
    },
    [type, data.debt_symbol, data.debt_address]
  );

  const yScaleValueFormatter = useCallback(
    (value: number) => {
      if (type === 'debt') {
        return formatNumber(value);
      } else {
        return formatCurrency(value);
      }
    },
    [type]
  );

  return (
    <LineChart
      key={type}
      data={data['results']}
      datasets={[
        {
          xField: 'date',
          yField: type
        }
      ]}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      timeFilter={timeFilter}
      config={config}
    />
  );
}
